/**
 * Created by mac002 on 1/2/17.
 */

const packageNumber = "0.0.31";

module.exports = {
  getPackageNumber: () => { return packageNumber;}
}



// WEBPACK FOOTER //
// ./src/helpers/VersionNumbers.js